const getButtonPadding = (spacings, size = 'medium') => {
  if (size === 'small') {
    return `${spacings.micro}rem ${spacings.xSmall}rem`;
  }
  return `${spacings.small}rem ${spacings.medium}rem`;
};
export default getButtonPadding;
